import { Configuration, LogLevel, PopupRequest } from '@azure/msal-browser';
import { PublicAppConfig } from '../types/appConfig';

export function buildMsalConfig(config: PublicAppConfig): Configuration {
  return {
    auth: {
      clientId: config.frontend.azureClientId,
      authority: `https://login.microsoftonline.com/${config.frontend.azureTenantId || 'organizations'}`,
      redirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
          if (containsPii) return;
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              break;
            case LogLevel.Warning:
              console.warn(message);
              break;
            default:
              break;
          }
        },
      },
    },
  };
}

export function buildLoginRequest(authorityTenant: string = 'organizations'): PopupRequest {
  return {
    scopes: [],
    authority: `https://login.microsoftonline.com/${authorityTenant}`,
  };
}

export function buildApiRequest(clientId: string, authorityTenant: string): PopupRequest {
  return {
    scopes: [`api://${clientId}/access_as_user`],
    authority: `https://login.microsoftonline.com/${authorityTenant}`,
  };
}
